/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRecurringDeposit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 10v1h-1a3 3 0 1 0 0 6h1v2h-3v2h3v1h2v-1h1a3 3 0 1 0 0-6h-1v-2h3v-2h-3v-1zm-1 3h1v2h-1a1 1 0 1 1 0-2zm3 6v-2h1a1 1 0 1 1 0 2zM3 4h3a9.985 9.985 0 0 0-4 8c0 5.148 3.89 9.386 8.89 9.939l.22-1.988A8.001 8.001 0 0 1 7 5.754V8h2V2H3zm16.545 5.333A8.004 8.004 0 0 0 12 4V2c4.356 0 8.058 2.784 9.43 6.667z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRecurringDeposit as RecurringDeposit };
